import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {QuoteCollation, QuoteCollationVap, QuotePageDataVaps} from '../../../models/quote.model';
import {Question, VapQuestion} from '../../../models/underwriter.model';
import {GlobalQuestionService} from '../../../services/global-question.service';

@Component({
    selector: 'app-vaps-vehicle-four',
    templateUrl: './vaps-vehicle-four.component.html',
    styleUrls: ['./vaps-vehicle-four.component.scss'],
    standalone: false
})
export class VapsVehicleFourComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() collations: QuoteCollation[];
  @Input() collation_vaps: QuoteCollationVap[];
  @Input() question: VapQuestion;
  @Input() currentVap: QuotePageDataVaps;
  @Input() productId: any;
  @Input() sessionId: any;
  @Input() addAddons = false;
  @Output() amountChanged = new EventEmitter<any>();
  @Output() addAddonsChanged = new EventEmitter<boolean>();
  productDetailsId: any;
  vaps = [];

  constructor(
    private ref: ChangeDetectorRef,
    private globalQuestionService: GlobalQuestionService) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.addAddons?.currentValue === true) {
      this.calculate();
      this.addAddonsChanged.emit(false);
    }
    if (changes?.question?.currentValue) {
      this.question = changes?.question?.currentValue;

      if (this.question?.answers) {
        this.question.answers_parsed = JSON.parse(this.question?.answers);
      }
    }
    if (changes?.collations?.currentValue) {
      this.collations = changes?.collations?.currentValue;
    }
    if (changes?.collation_vaps?.currentValue) {
      this.collation_vaps = changes?.collation_vaps?.currentValue;
    }
    if (changes?.currentVap?.currentValue) {
      this.currentVap = changes?.currentVap?.currentValue;
    }
    if (changes?.productId?.currentValue) {
      this.productId = changes?.productId?.currentValue;
    }
    if (changes?.productId?.currentValue || changes?.currentVap?.currentValue
      || changes?.collation_vaps?.currentValue || changes?.collations?.currentValue
      || changes?.question?.currentValue) {
      this.amountChanged.emit(0);
      this.vaps = [];
      this.getProductDetails();
    }
  }

  ngAfterViewInit(): void {
    this.ref.detectChanges();
  }

  getProductDetails(): any {
    if (this.getVapPrice(this.currentVap)) {
      for (const c of this.collations) {
        if (c.class_id === 10 && c.entry_type === 'item' && c.description_1 && c.product_id === this.productId) {
          const item = {
            description: c.description_1.split('|'),
            option_id: '',
            checked: false,
            is_active: false,
            toggle: false,
            show: false,
            price: 0,
            session_item_id: c?.session_item_id,
            value: ''
          } as any;

          for (const v of this.collation_vaps) {
            if (v.class_id === 10 && v.select === 1 && v.session_item_id === c.session_item_id && this.currentVap?.product_vaps_id === v.product_vaps_id) {
              /*item.option_id = v?.option_id;*/
              item.checked = true;
              item.is_active = true;
              item.toggle = true;
              item.show = false;
              item.price = v?.premium ? v.premium : 0;
              /*item.value = v?.detail.substring(v?.detail.indexOf('|') + 1, v?.detail?.length);*/

              if (this.question?.answers_parsed?.length) {
                for (const i of this.question?.answers_parsed) {
                  const answer = i?.answer?.split('|');
                  if (answer?.length && answer[0].toString() === v?.session_item_id?.toString()) {
                    item.option_id = answer[1]?.toString();
                    item.value = answer[2];
                  }
                }
              }
              this.vaps.push(item);
            }
          }

          if (!this.vaps.some(x => x.session_item_id === c?.session_item_id)) {
            item.description = c?.description_1?.split('|');
            item.session_item_id = c?.session_item_id;
            item.price = 0;
            item.show = false;
            this.vaps.push(item);
          }
        }
      }
    } else {
      for (const c of this.collations) {
        if (c.class_id === 10 && c.entry_type === 'item' && c.description_1 && c.product_id === this.productId) {
          const item = {
            description: c?.description_1?.split('|'),
            option_id: '',
            checked: false,
            is_active: false,
            toggle: false,
            show: false,
            price: 0,
            session_item_id: c?.session_item_id,
            value: ''
          } as any;

          this.vaps.push(item);
        }
      }
    }
  }

  getVapPrice(v: QuotePageDataVaps): string {
    let price = '';
    for (const c of this.collations) {
      if (v.product_vaps_id === c.vaps_id) {
        price = c.prem_value.toString();
      }
    }
    return price;
  }

  calculate(): void {
    for (let i = 0; i < this.vaps?.length; i++) {
      if (this.vaps[i].checked) {
        this.onChange(i, 1);
      }
    }
  }

  onInputChange(index: number): void {
    this.onChange(index, 0);
  }

  selectChange(value: Question, index: number): void {
    this.vaps[index].option_id = value?.answer;
    this.onChange(index, 0);
  }

  checkAddon(index: any): void {
    this.vaps[index].checked = !this.vaps[index].checked;
    this.vaps[index].is_active = !this.vaps[index].is_active;
    this.vaps[index].show = !this.vaps[index].show;
    if (this.vaps[index].checked) {
      this.onChange(index, 0);
    } else {
      this.vaps[index].price = 0;
      this.onChange(index, 0);
    }
  }

  onChange(index: number, action: number): void {
    if (this.vaps[index]?.value && this.vaps[index]?.option_id) {
      if (action === 1) {
        this.globalQuestionService.spinner(true);
      }
      const answer = action.toString() + '|' + this.vaps[index]?.option_id.toString() + '|' + this.vaps[index]?.value.toString();
      this.question.answer = answer;
      this.globalQuestionService.saveAnswer(this.sessionId, this.question?.cent_aq_question_id, 1, this.vaps[index]?.session_item_id, answer, 0, '')
        .subscribe(() => {
          if (action === 1) {
            this.globalQuestionService.resetVaps(true);
            this.globalQuestionService.spinner(false);
          } else {
            this.globalQuestionService.calcPremiumAddons(this.currentVap?.product_vaps_id, this.vaps[index]?.session_item_id, this.productId)
              .subscribe((p: any[]) => {
                if (p?.length) {
                  p?.forEach(item => {
                    if (this.vaps[index].session_item_id === item?.session_item_id && this.vaps[index]?.checked) {
                      this.vaps[index].price = item?.premium;
                    }
                  });
                  this.amountChanged.emit(this.vaps.filter(i => i?.checked));
                  this.globalQuestionService.spinner(false);
                  this.globalQuestionService.resetVaps(false);
                }
              });
          }
        });
    } else {
      this.vaps[index].price = 0;
      this.amountChanged.emit(this.vaps);
    }
  }
}
